/*
 * @Author: your name
 * @Date: 2021-05-27 16:39:25
 * @LastEditTime: 2021-05-27 16:59:44
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \PPTist\src\views\components\element\VideoElement\useFilter.ts
 */
import { computed, Ref } from 'vue'
import { VideoElementFilters } from '@/types/slides'

export default (filters: Ref<VideoElementFilters | undefined>) => {
  const filter = computed(() => {
    if (!filters.value) return ''
    let filter = ''
    for (const key of Object.keys(filters.value)) {
      filter += `${key}(${filters.value[key]}) `
    }
    return filter
  })

  return {
    filter,
  }
}